<template>
  <div class="modal fade" id="locationModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-identify">
      <div class="modal-content modal-content-identify modal-content-location">
        <div class="modal-header modal-header-identify modal-header-location">
          <label class="">Location management</label><br>
        </div>
        <div class="modal-body modal-body-identify modal-body-location">
          <div class="container-fluid identify-modal-container location-modal-container right-container">
            <label>Name:</label><br>
            <input type="text" class="location-name-input" v-model="locationName"><br><br>
            <label>Is classroom:</label><br>
            <input type="checkbox" name="is-classroom" v-model="isClassroom" id="">
          </div>
        </div>
        <div class="modal-footer modal-footer-identify modal-footer-location">
          <button type="button" class="btn btn-primary my-btn btn-identify btn-location-modal" @click.prevent="storeLocation();" data-dismiss="modal">
            <span v-if="action == 'add'">Add location</span>
            <span v-if="action == 'edit'">Edit location</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LocationModal',
    props: {
      item: {
      },
      action: '',
    },
    data() {
      return {
        locationName : '',
        isClassroom : '',
      };
    },
    watch: {
      item(newVal) {
        this.isClassroom = newVal.is_classroom;
        this.locationName = newVal.name;
      }
    },
    methods: {
      storeLocation() {
        if(this.action == 'add') {
          this.addLocation();
        }
        if(this.action == 'edit') {
          this.editLocation();
        }
      },
      addLocation() {
        let data = new FormData();

        data.set('name', this.locationName);
        data.set('is_classroom', this.isClassroom ? 1 : 0);

        this.axios.post(`/location`, data)
          .then(() => {
            this.$emit('snotify', {status: 'success', message: 'Location successfully added.'});
            this.$emit('locations-changed');
          })
          .catch(() => this.$emit('snotify', {status: 'error', message: 'An error occured.'}));
      },
      editLocation() {
        let data = new FormData();

        data.set('location_id', this.item.id);
        data.set("fields", JSON.stringify(['name', 'is_classroom']));
        data.set("values", JSON.stringify([this.locationName, this.isClassroom ? 1 : 0]));

        this.axios.put(`/location`, data)
          .then(() => {
            this.$emit('snotify', {status: 'success', message: 'Location successfully edited.'});
            this.$emit('locations-changed');
          })
          .catch(() => this.$emit('snotify', {status: 'error', message: 'An error occured.'}));
      }
    }
  };
</script>
